var _classCallCheck = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/defineProperty", "react", "lodash.debounce"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("lodash.debounce"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a._extends, a.defineProperty, a.react, a.lodash), a.withDeviceSize = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e) {
  "use strict";

  var f = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.withDeviceSize = void 0, b = f(b), c = f(c), d = f(d), e = f(e);

  var g = function g() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$desktop = _ref.desktop,
        a = _ref$desktop === void 0 ? 1025 : _ref$desktop,
        _ref$phone = _ref.phone,
        f = _ref$phone === void 0 ? 559 : _ref$phone;

    return function (g) {
      var h =
      /*#__PURE__*/
      function (_d$default$Component) {
        _inherits(h, _d$default$Component);

        function h() {
          var _getPrototypeOf2;

          var _this;

          _classCallCheck(this, h);

          for (var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++) {
            b[_key] = arguments[_key];
          }

          _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(h)).call.apply(_getPrototypeOf2, [this].concat(b))), (0, c.default)(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", !1), (0, c.default)(_assertThisInitialized(_assertThisInitialized(_this)), "updateWindowDimensions", (0, e.default)(function () {
            if (!_this.mounted) return;
            var b = global.innerWidth,
                c = b < a,
                d = b <= f;

            _this.setState(function (_ref2) {
              var a = _ref2.isMobileSized,
                  b = _ref2.isPhoneSized;
              var e = {};
              return c !== a && (e.isMobileSized = c), d !== b && (e.isPhoneSized = d), e;
            });
          }, 300)), (0, c.default)(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
            isMobileSized: !1,
            isPhoneSized: !1
          });
          return _this;
        }

        _createClass(h, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.mounted = !0, this.updateWindowDimensions(), global.addEventListener("resize", this.updateWindowDimensions);
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.mounted = !1, global.removeEventListener("resize", this.updateWindowDimensions);
          }
        }, {
          key: "render",
          value: function render() {
            var a = this.state,
                c = a.isPhoneSized,
                e = a.isMobileSized;
            return d.default.createElement(g, (0, b.default)({}, this.props, {
              isMobileSized: e,
              isPhoneSized: c
            }));
          }
        }]);

        return h;
      }(d.default.Component);

      var i = g.displayName || g.name;
      return h.displayName = "withDeviceSize(".concat(i, ")"), h;
    };
  };

  a.withDeviceSize = g;
  a.default = g;
});